// AboutSection.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './AboutSection.css';
import { Link } from 'react-router-dom';
import { Images } from "../../../../assets/assets";
import { useHomeStore } from '../../../../store/useHomeStore';
import Loader from '../../../Loader';

const AboutSection = () => {
    const { about, getHome } = useHomeStore()
    const [loading, setLoading] = useState(false)

    const fetchHomeData = async () => {
        setLoading(true)
        await getHome()
        setLoading(false)
    }

    useEffect(() => {
        if (!about) {
            fetchHomeData()
        }
    }, [about])

    return (
        <div className="about-section py-5">
            <Loader loading={loading}>
                <Container className='theme-container'>
                    <Row className="align-items-center">
                        <Col md={5} className="position-relative text-center mb-4 mb-md-0">
                            <div className="experience-badge">
                                <h3 className="badge-years">{`${about?.experience}+`}</h3>
                                <p className="badge-text">YEARS<br />INDUSTRY<br />SERVICE</p>
                            </div>
                            <div className='about-left-section-img'>
                                <img className="img-fluid" src={about?.image} alt="excavator image" />
                            </div>
                        </Col>
                        <Col md={7}>
                            <div className='about-right-col-content'>
                                <p className="section-subtitle">{about?.subTitle}</p>
                                <h3 className="section-title">{about?.title}</h3>
                                <p className="section-description text-light-gray fs-6 mt-xl-4 mt-lg-3 mt-2">
                                    {about?.description?.split("\n").map((line, idx) => (
                                        <span key={idx}>
                                            {line} <br />
                                        </span>
                                    ))}
                                </p>

                                <div className='hero-btn-holder mt-xl-4 mt-lg-3 mt-2'>
                                    <Link to="/contact-us" className="btn btn-solid-black">
                                        <span className="fw-bold me-3 ">{about?.buttonText}</span>
                                        <img className="img-fluid" src={Images.FancyWhiteCornerIcon} alt="Phone icon" />
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Loader>
        </div>
    );
};

export default AboutSection;
